import { useLocation } from "react-router-dom";
import { Box, useTheme, Link } from "@mui/material/";
import Container from "../Layout/Container/";
import AcceptanceMarks from "../AcceptanceMarks";
import { GLOBAL_ACCEPTANCE_PATH, FAQS_PATH } from "../../routes";

const PREFIX = "Header";

const classes = {
  logos: `${PREFIX}-logos`,
};

const Header = () => {
  const theme = useTheme();
  const location = useLocation();
  const linkLogos =
    location.pathname === FAQS_PATH ||
    location.pathname === `${FAQS_PATH}/`;

  return (
    <Container
      component="header"
      zIndex="3"
      position="relative"
      height="auto"
      top={0}
      paddingY={2}
      display="flex"
      justifyContent="center"
      boxShadow="none"
      isWrapper={false}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        maxWidth={theme.containerMaxWidth}
      >
        <Box
          component={linkLogos ? Link : Box}
          href={linkLogos ? GLOBAL_ACCEPTANCE_PATH : undefined}
          className={linkLogos ? classes.logos : undefined}
          sx={{
            display: "inline-block",
            ...(linkLogos && {
              "& img": {
                transition: "all .2s",
              },
              "&:focus, &:hover": {
                "& img": {
                  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.3)",
                },
              },
            }),
          }}
        >
          <AcceptanceMarks
            marks={["DCI", "DN"]}
            variant="small"
            marksStyles={{ marginRight: theme.spacing(2) }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Header;
